import { render, staticRenderFns } from "./BenefitVoucherFormFields.vue?vue&type=template&id=05de3340&scoped=true"
import script from "./BenefitVoucherFormFields.vue?vue&type=script&lang=js"
export * from "./BenefitVoucherFormFields.vue?vue&type=script&lang=js"
import style0 from "./BenefitVoucherFormFields.vue?vue&type=style&index=0&id=05de3340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05de3340",
  null
  
)

export default component.exports